module.exports = __webpack_public_path__ + "img/3.1.1.28207e41.png";